import React from 'react';
import { Button } from 'primereact/button';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';

const FloatingButton = ({ onClick }) => {
    return (
        <Button type='button'
            icon="pi pi-question-circle"
            className="p-button-rounded p-button-primary floating-tour-button"
            onClick={onClick}  // Przekazanie funkcji onClick
        />
    );
};

export default FloatingButton;